<template>
  <div>
    <header>
      <svg
        width="78"
        height="101"
        viewBox="0 0 78 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.5532 70.2166H34.0213C32.234 70.2166 30.9574 71.7431 31.2128 73.5239H38.8723C41.1702 71.2343 43.7234 69.4534 46.5319 68.1814C45.766 65.1285 45.2553 61.8212 45.5106 58.7683C43.2128 59.0227 41.1702 59.2771 38.8723 60.0403C38.1064 60.2947 37.8511 60.8035 38.1064 61.5667C38.8723 63.3476 39.6383 65.1285 40.4043 66.9093C38.8723 67.9269 37.5957 68.9446 36.3191 70.2166C36.0638 70.2166 35.8085 70.2166 35.5532 70.2166ZM55.9787 39.9421C55.4681 40.9597 55.4681 42.2317 56.4894 43.2494C58.5319 45.0302 60.8298 46.0479 62.1064 48.5919C62.8723 49.864 63.8936 52.4081 61.5957 52.6625C59.5532 52.9169 56.4894 50.8816 54.7021 49.6096C55.4681 50.6272 55.7234 51.8992 56.234 52.9169C56.4894 53.4257 56.7447 53.6801 57 53.6801C59.0426 54.6977 62.3617 55.461 63.8936 53.4257C65.4255 51.6448 64.9149 49.3552 63.383 47.3199C61.8511 44.7758 59.2979 44.0126 57.5106 41.9773C57.2553 41.7229 57 41.2141 57.2553 40.9597C57.5106 40.1965 58.2766 39.9421 59.0426 39.9421C60.0638 39.6877 61.3404 39.4332 62.1064 39.1788C62.8723 38.67 63.1277 37.9068 63.383 37.398L63.6383 36.1259C61.8511 36.6348 59.8085 37.1436 58.2766 37.9068C57.766 38.4156 56.4894 39.1788 55.9787 39.9421ZM29.6809 29.2569C33 23.4055 36.8298 17.8086 40.9149 12.466C41.6809 9.92191 41.1702 7.88665 40.1489 5.85139L38.1064 1.27204C33.766 8.39547 29.9362 15.7733 26.617 23.4055C26.1064 24.4232 26.3617 25.6952 27.1277 26.4584C27.8936 27.2217 28.9149 28.2393 29.6809 29.2569ZM17.6809 73.5239C24.3192 64.1108 35.0426 58.005 46.5319 57.4962C47.5532 60.8035 49.3404 63.8564 51.383 66.6549C55.2128 65.8917 59.0426 66.1461 62.617 67.1637L63.6383 69.7078C63.6383 69.9622 63.6383 70.2166 63.383 70.2166H62.3617C60.5745 70.2166 59.2979 71.7431 59.5532 73.5239H66.7021C67.7234 73.5239 68.4894 72.5063 68.234 71.4887L65.1702 63.602C63.1277 62.8388 61.0851 62.5844 59.0426 62.33L54.7021 51.136C53.9362 49.1008 51.383 48.0831 49.5957 47.5743C47.5532 47.0655 45 46.8111 42.7021 47.0655C45.2553 45.7934 47.8085 44.5214 50.617 43.5038C52.1489 42.995 53.1702 41.7229 53.6809 40.4509C54.1915 39.1788 54.4468 38.1612 54.9575 36.8892C52.6596 37.9068 50.3617 38.9244 48.0638 40.1965C49.5957 39.1788 51.1277 38.1612 52.6596 37.1436C54.7021 35.8715 55.7234 34.5995 56.234 32.5642C56.4894 31.0378 56.7447 29.7657 57 28.2393C54.1915 29.2569 51.1277 30.7834 48.5745 32.0554C49.8511 31.0378 51.8936 29.7657 53.1702 29.0025C55.9787 27.2217 57.5106 24.4232 57.766 21.1159C57.766 19.5894 57.766 18.063 57.766 16.7909C53.9362 19.0806 50.1064 21.3703 46.5319 24.1688C48.5745 22.1335 50.617 20.0982 52.9149 18.3174C56.234 15.2645 57.5106 11.194 56.7447 6.86902C56.234 4.57935 55.7234 2.28967 54.9575 0C50.617 4.07053 46.5319 8.64987 42.7021 13.2292C38.617 18.3174 34.7872 23.9144 31.2128 29.5113C30.7021 30.529 30.7021 31.5466 31.2128 32.3098C32.4894 34.0907 33.766 36.1259 34.2766 38.1612C35.8085 44.0126 32.7447 45.7935 29.6809 48.0831C28.9149 48.5919 28.9149 48.0831 29.1702 47.8287C29.4255 47.5743 29.6809 47.3199 29.9362 47.0655C32.234 45.0302 32.4894 41.2141 30.9574 38.4156C28.9149 34.8539 26.1064 31.5466 22.7872 29.0025C22.2766 30.2746 21.5106 31.5466 19.4681 32.8186C18.1915 33.5819 15.383 35.6171 13.0851 38.9244C14.1064 40.4509 15.1277 41.4685 16.6596 42.4861C17.1702 41.9773 17.6809 41.4685 18.4468 40.9597C18.9574 40.4509 19.7234 40.7053 19.9787 41.2141C20.4894 40.7053 20.4894 41.4685 19.9787 41.9773L19.4681 42.4861C18.9574 42.995 18.1915 42.7406 17.9362 42.2317C17.9362 42.2317 17.9362 41.9773 17.6809 41.9773L17.1702 42.4861C17.6809 43.5038 18.4468 45.2846 18.7021 45.2846C18.9574 45.2846 18.9574 45.2846 19.2128 45.0302L21.2553 43.2494C21.2553 42.995 21.5106 43.2494 21.5106 43.5038C19.4681 47.3199 17.1702 51.8992 15.8936 55.9698C15.6383 56.733 15.8936 57.4962 16.1489 58.005C17.1702 59.7859 18.9574 61.5668 19.4681 62.0756C17.6809 64.3652 16.1489 66.9093 14.8723 69.4534C14.617 69.9622 14.1064 70.2166 13.3404 70.2166H11.2979C9.51064 70.2166 8.23404 71.7431 8.48936 73.5239H17.6809ZM38.3617 83.4458H33.2553L25.5957 90.8237V83.4458H21.5106V100.491H25.5957V95.9118L28.4043 93.3678L33.5106 100.746H38.8723L31.7234 90.5693L38.3617 83.4458ZM58.7872 83.4458H53.6809L46.0213 90.8237V83.4458H41.9362V100.491H46.0213V95.9118L48.8298 93.3678L53.9362 100.746H59.2979L52.1489 90.5693L58.7872 83.4458ZM13.3404 83.4458C12.0638 83.1914 10.5319 82.937 9.25532 82.937C7.97872 82.937 6.44681 83.1914 5.17021 83.4458C2.87234 83.9547 1.08511 85.7355 0.574468 88.0252C-0.191489 90.8237 -0.191489 93.3678 0.574468 96.1662C1.08511 98.4559 2.87234 100.237 5.17021 100.746C6.44681 100.746 7.97872 101 9.25532 101C10.5319 101 12.0638 100.746 13.3404 100.491C15.6383 99.9824 17.4255 98.2015 17.9362 95.9118C18.7021 93.1133 18.7021 90.5693 17.9362 87.7708C17.4255 85.7355 15.6383 83.9547 13.3404 83.4458ZM14.1064 94.8942C13.8511 95.6574 13.3404 96.4207 12.3192 96.4207C10.2766 96.9295 8.23404 96.9295 5.93617 96.4207C5.17021 96.1662 4.40426 95.6574 4.14894 94.8942C3.6383 92.8589 3.6383 90.8237 4.14894 88.7884C4.40426 88.0252 4.91489 87.262 5.93617 87.262C7.97872 86.7531 10.0213 86.7531 12.3192 87.262C13.0851 87.5164 13.8511 88.0252 14.1064 88.7884C14.617 90.8237 14.617 92.8589 14.1064 94.8942ZM77.4255 87.7708C76.9149 85.4811 75.1277 83.7002 72.8298 83.1914C71.5532 82.937 70.0213 82.6826 68.7447 82.6826C67.4681 82.6826 65.9362 82.937 64.6596 83.1914C62.3617 83.7002 60.5745 85.4811 60.0638 87.7708C59.2979 90.5693 59.2979 93.1133 60.0638 95.9118C60.5745 98.2015 62.3617 99.9824 64.6596 100.491C65.9362 100.746 67.4681 101 68.7447 101C70.0213 101 71.5532 100.746 72.8298 100.491C75.1277 99.9824 76.9149 98.2015 77.4255 95.9118C78.1915 93.3678 78.1915 90.5693 77.4255 87.7708ZM73.5957 94.8942C73.3404 95.6574 72.8298 96.4207 71.8085 96.4207C69.766 96.9295 67.7234 96.9295 65.4255 96.4207C64.6596 96.1662 63.8936 95.6574 63.6383 94.8942C63.1277 92.8589 63.1277 90.8237 63.6383 88.7884C63.8936 88.0252 64.4043 87.262 65.4255 87.262C67.4681 86.7531 69.5106 86.7531 71.8085 87.262C72.5745 87.5164 73.3404 88.0252 73.5957 88.7884C74.1064 90.8237 74.1064 92.8589 73.5957 94.8942Z"
          fill="#FEEA01"
        />
      </svg>
      <span>ФАКТИ<br />ПРО АРКТИКУ</span>
    </header>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @import '~styles/scss/media.scss';
  header {
    position: absolute;
    left: 0;
    top: 37px;
    z-index: 100;
    svg,
    span {
      vertical-align: middle;
    }
    span {
      font: 800 52px/50px ProximaNovaCondensed;
      color: #feea01;
      display: inline-block;
      padding-left: 53px;
    }
    @include respond-to(medium) {
      top: 22px;
      svg {
        width: 65px;
        height: 84px;
      }
      span {
        font-size: 40px;
        line-height: 40px;
        padding-left: 51px;
      }
    }
    @include respond-to(tabletRotate) {
      span {
        font-size: 40px;
        line-height: 40px;
        padding-left: 32px;
      }
      @media screen and (max-height: $mm-h) {
        top: 0px;
        svg {
          width: 65px;
          height: 84px;
        }
        span {
          font-size: 40px;
          line-height: 40px;
          padding-left: 22px;
        }
      }
    }
    @include respond-to(tablet) {
      top: 15px;
    }
    @include respond-to(mobileRotate) {
      top: 0px;
      svg {
        width: 43px;
        height: 55px;
      }
      span {
        font-size: 25px;
        line-height: 25px;
        padding-left: 22px;
      }
    }

    @media screen and (max-height: $m-h) {
      top: 0;
      svg {
        width: 43px;
        height: 55px;
      }
      span {
        font-size: 25px;
        line-height: 25px;
        padding-left: 22px;
      }
    }
    @media screen and (max-height: $sm-h) {
      top: 0;
      svg {
        width: 35.18px;
        height: 45px;
      }
      span {
        font-size: 20.4545px;
        line-height: 20px;
        padding-left: 18px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue